// extracted by mini-css-extract-plugin
module.exports = {"button3":"CategoryDelete_button3__22zJ0","selectCategory":"CategoryDelete_selectCategory__2pt1m","label":"CategoryDelete_label__1WvnB","General":"CategoryDelete_General__1QXd3"};